<template>
  <div class="app--lhn">
    <mc-c-left-hand-nav
      v-if="showLHN"
      fit="medium"
      :selecteditem="selectedNavigationItem"
      data-test="left-hand-nav"
      @navitemclick="sendNavClickToOrbit"
    />
    <div id="shipment_app" class="shipment-overview" data-test="shipment-overview">
      <router-view :key="$route.fullPath" />
    </div>
  </div>
</template>

<script>
import { getBrandFromHostname, getUserCredential } from "@maersk-global/shared-js";
import "@maersk-global/community-ui-left-hand-nav";

export default {
  name: "App",
  computed: {
    showLHN() {
      return !(
        getBrandFromHostname(globalThis.location).brandCode.toUpperCase() === "MAEI" ||
        this.$route.name === "order-bl-paper" ||
        this.$route.name === "duplicate"
      );
    },
    selectedNavigationItem() {
      const pathname = globalThis.location?.pathname || "";
      if (pathname.includes("import")) {
        return "importOverview";
      } else if (pathname.includes("export")) {
        return "exportOverview";
      }
      return false;
    }
  },
  mounted() {
    localStorage.removeItem("defaultOverview");
  },
  created() {
    this.setDocumentTitle();
  },
  methods: {
    setDocumentTitle() {
      const currentUrl = globalThis.location;
      let pageTitle = "";

      if (currentUrl?.pathname?.includes("order-bl-paper")) {
        pageTitle = " :: Order BL Paper";
      } else if (currentUrl?.pathname?.includes("import")) {
        pageTitle = " :: Import Overview";
      } else if (currentUrl?.pathname?.includes("duplicate")) {
        pageTitle = " :: Duplicate Shipment";
      } else {
        pageTitle = " :: Export Overview";
      }

      return (document.title = `${getBrandFromHostname(currentUrl)?.commercialName} ${pageTitle}`);
    },
    sendNavClickToOrbit(e) {
      // we need to send the english title :(
      const items = {
        hub: "Hub dashboard",
        exportOverview: "Export overview",
        importOverview: "Import overview",
        tasks: "Tasks",
        myCustoms: "MyCustoms",
        myFinance: "MyFinance",
        allocations: "Allocations",
        captainPeter: "Captain Peter",
        support: "Support",
        manageBookings: "Manage Bookings"
      };

      this.$sendGAEvent({
        event: "DQCS",
        category: "LHN",
        action: "Click",
        label: { data: items[e.detail.value.key] }
      });
      globalThis.faro?.api.pushEvent("eventLHN", {
        personId: getUserCredential("personid"),
        action: items[e.detail.value.key]
      });
    }
  }
};
</script>
